class PropertyHealth {
    crowdfunding;
    resale;
    constructor(data) {
        this.crowdfunding = data.crowdfunding;
        this.resale = data.resale;
    }
}
export default PropertyHealth;
